/*******************************************************************************
 * Copyright (c) 2023 GetChkd
 *
 * All rights reserved.
 *
 * Contributors:
 *  James Worthington - Initial implementation
 *  Amina Rais - Massive Improvements
 *  Version: 2.0.0
 *
 *******************************************************************************/

import { createAsyncThunk } from "@reduxjs/toolkit";
import * as api from '../../../../services'

 
export const getAllOrgsUsers = createAsyncThunk('orgUsers/getAllOrgsUsers', async (_, { rejectWithValue }) => {
    try { 
        const data = await api.orgUsers
        .getAllOrgsUsers()
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getOrgUserHistory = createAsyncThunk('orgUsers/getOrgUserHistory', async (orgid, { rejectWithValue }) => {
    try { 
        const data = await api.orgUsers.getOrgUserHistory(orgid)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})
export const getAllOrgsUsersByOrgID = createAsyncThunk('orgUsers/getAllOrgsUsersByOrgID', async (params, { rejectWithValue }) => {
    try { 
        const data = await api.orgUsers.getAllOrgsUsersByOrgID(params)
        return Promise.resolve(data)
    } catch (error) {
        return rejectWithValue(error.message);
    }
})